import {
  CalendarIcon,
  CircleCheckIcon,
  EarthIcon,
  MailIcon,
  UserRoundIcon,
  VideoIcon,
} from "lucide-react";

import { Modal } from "../ui/Modal";

import { formatMeetingTimeRange } from "../../lib/utils";

import { useMeetingSummaryModal } from "../../hooks/useMeetingSummaryModal";
import { useMeetingDetails } from "../../hooks/useMeetingDetails";

import RyanAvatar from "../../images/ryan-avatar.png";

export const MeetingSummaryModal = () => {
  const { isOpen, onClose } = useMeetingSummaryModal();
  const {
    date,
    time,
    userName,
    userEmail,
    userTimezone,
    setDate,
    setTime,
    setTimezone,
    setUserName,
    setUserEmail,
  } = useMeetingDetails();

  const onMSMClose = () => {
    onClose();

    setDate(undefined);
    setTime("");
    setTimezone({
      value: Intl.DateTimeFormat().resolvedOptions().timeZone,
      label: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    setUserName("");
    setUserEmail("");
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onMSMClose}
      className="py-10 px-20 flex flex-col items-center gap-y-7"
    >
      <img src={RyanAvatar} alt="Ryan" className="size-[100px]" />

      <div className="flex flex-col items-center space-y-2">
        <div className="flex items-center gap-x-2.5">
          <CircleCheckIcon className="text-[#01C2F3]" />{" "}
          <p className="font-bold text-white">You are scheduled</p>
        </div>
        <p className="text-sm text-white">
          A calendar invitation has been sent to your email address.
        </p>
      </div>

      <div className="py-4 px-8 border border-gray-800 rounded-lg space-y-2.5">
        <h1 className="font-bold text-white">Schedule eClosing</h1>

        <div className="flex items-center gap-x-2">
          <UserRoundIcon className="text-white" />
          <p className="font-bold text-gray-500">{userName}</p>
        </div>
        <div className="flex items-center gap-x-2">
          <MailIcon className="text-white" />
          <p className="font-bold text-gray-500">{userEmail}</p>
        </div>
        <div className="flex items-center gap-x-2">
          <CalendarIcon className="text-white" />
          <p className="font-bold text-gray-500">
            {formatMeetingTimeRange(time)},{" "}
            {date &&
              date.toLocaleDateString("en-US", {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric",
              })}
          </p>
        </div>
        <div className="flex items-center gap-x-2">
          <EarthIcon className="text-white" />
          <p className="font-bold text-gray-500">
            {(userTimezone as any).value}
          </p>
        </div>
        <div className="flex items-center gap-x-2">
          <VideoIcon className="text-white" />
          <p className="font-bold text-gray-500">
            Web conferencing details to follow.
          </p>
        </div>
      </div>
    </Modal>
  );
};
